import { Col, Form, Input, Row } from 'antd';
import { useEffect, useRef, useState, } from 'react'
import { httpGet } from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import systemConfig from '../../../config/systematic';
import WebProductFormList from '../../generalComponents/WebProductFormList';

export default function IncomeStatementEdit(props: any) {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    const [deleteData, setDeleteData] = useState<any>();
    const [formList, setFormList] = useState<any>({ formName: "incomeStatementProducts", form, type: data.type, ref, setDeleteData, orderType: "incomeStatement" })
    const [loading, setLoading] = useState<boolean>(false)
    /** 后端数据Service */
    let wmService: any = systemConfig.wmService;
    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'incomeStatement',
        formListName: "incomeStatementProducts",
        mountDataOptions: {
            userMount: {
                isEmployees: true,
                isDept: true,
                isUserAreas: true
            }
        },
    };
    useEffect(() => {
        let deptId = localStorage.getItem("deptId")
        if (deptId) {

            httpGet(wmService, {
                apiId: "entrepot",
                apiExtend: 'getDeptIdToEntrepot',
                apiData: {
                    mountDataOptions: {
                        userMount: {
                            isEmployees: true,
                        }
                    },
                }
            }).then(res => {

                if (res.success) {
                    form.setFieldsValue({
                        "entrepotId": res.data.id
                    })
                }
            }).catch((err) => {
                console.log("无数据");

            })
        }
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }
        const fetchData = async () => {


            // httpGet(wmService, {
            //     apiId: "product",
            //     apiExtend: 'showList'
            // }).then(res => {
            //     setProductData(res.data)
            // })


        }
        fetchData()
    }, [])



    return (
        <>
            <WebEditUniversal setLoading={setLoading}  totalData={deleteData} ref={ref} props={extendProps}></WebEditUniversal>
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '溢损单'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={"70%"}
                confirmLoading={loading}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                //    onKeyDown={(e: any) => {
                //         if (e.key === 'Enter') {
                //             handleOk(e)
                //         }
                //     }}
                >
                    <Row >

                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>





                        <WebProductFormList props={formList}></WebProductFormList>

                    </Row>
                </Form>
            </AntDraggableModal>

        </>
    )
}
